import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = ["alt", "src"]
const _hoisted_3 = { class: "name" }

import { useStore } from 'vuex';
  import { computed,onMounted } from 'vue';
  import { debounce } from 'lodash'; // 确保安装了 lodash
  import { ref } from 'vue';
  import { ExternalFun } from '../../ExternalFun';
  interface User {
    name: string;
    imgId: number;
  }
  
  // 使用 Composition API
  
export default /*@__PURE__*/_defineComponent({
  __name: 'card',
  setup(__props) {

  const imageUrl = ref(null);
  // 定义接口 (类型)
  const store = useStore();
  
  // 用户信息 (计算属性)
  const user = computed<User>(() => store.state.user);
  // 搜索函数 (防抖处理)
  const onKeyup = debounce((value: string) => {
    store.commit('SET_FILTER_KEY', value); // 触发 mutation
  }, 150); // 150ms 防抖延迟
  
  // 本地 onKeyup 函数，用于处理 input 事件
  const handleKeyup = (e: Event) => { // KeyboardEvent -> Event
    const target = e.target as HTMLInputElement;
    onKeyup(target.value); // 调用防抖函数
  };

  onMounted(async () => {
 
  })  

 

  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("img", {
        class: "avatar",
        width: "40",
        height: "40",
        alt: user.value.name,
        src: _unref(ExternalFun).getImageUrl(user.value.imgId),
        style: {"display":"none"}
      }, null, 8, _hoisted_2),
      _createElementVNode("p", _hoisted_3, _toDisplayString(user.value.name), 1)
    ]),
    _createElementVNode("footer", null, [
      _createElementVNode("input", {
        class: "search",
        type: "text",
        placeholder: "search user...",
        onKeyup: handleKeyup
      }, null, 32)
    ])
  ]))
}
}

})